<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      款项分配信息
    </div>
    <div class="rj-page-card__content">
      <div class="table">
        <el-table
          :data="tableData"
          border
          max-height="400"
          show-summary
          :summary-method="getSummaries"
        >
          <!-- <el-table-column type="index" width="70" label="序号" align="left" />
          <el-table-column prop="salesInvoiceName" label="汇款编号" align="left" min-width="130" />
          <el-table-column prop="productName" label="合同号" align="left" min-width="130" />
          <el-table-column prop="productNum" label="分配金额" align="left" width="100" />
          <el-table-column prop="productPriceSigle" label="分配比例" align="left" width="100" />
          <el-table-column prop="orderAmount" label="分配人" align="left" width="100" />
          <el-table-column prop="settlementAmount" label="分配时间" align="left" width="150" /> -->

          <el-table-column type="index" width="70" label="序号" align="left" />
          <el-table-column prop="telegraphicTransferNum" label="汇款编号" align="left" />
          <el-table-column prop="contractSum" label="订单金额" align="right" header-align="left" />
          <el-table-column prop="assignAmount" label="已分配金额" align="right" header-align="left" />
          <el-table-column prop="usedScale" label="分配金额比例" align="right" header-align="left" />
          <el-table-column prop="createBy" label="分配人" align="left" />
          <el-table-column prop="createTime" label="分配日期" align="left" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { selectAssignDetailByContractId } from '@/API';
import { MathAdd, numDiv } from '@/libs/util';
export default {
  // 产品列表
  name: 'ViewProductList',
  props: {
    contractId: {
      type: [String, Number],
      required: true
    },
    contractStatus: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    allAssignAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.assignAmount);
      });
      return cont;
    }
  },
  data () {
    return {
      tableData: [],
      loading: false
    };
  },
  methods: {
    initData () {
      this.loading = true;
      selectAssignDetailByContractId(this.contractId).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '订单金额' && this.tableData.length) {
          sums[index] = this.tableData[0].contractSum;
          return;
        }
        if (column.label === '已分配金额') {
          sums[index] = this.allAssignAmount;
          return;
        }
        if (column.label === '分配金额比例' && this.tableData.length) {
          let pre = (numDiv(this.allAssignAmount * 100, this.tableData[0].contractSum)).toFixed(2);
          sums[index] = `${pre}%`;
        }
      });
      return sums;
    }
  },
  mounted () {
    this.initData();
  }
};
</script>

<style lang="scss" scoped>

</style>
